var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Room.NormalIntoHistory",
    "options": {
        "java_package": "com.asiainno.uplive.proto",
        "objc_class_prefix": "RoomNormalIntoHistory"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "page",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "pageSize",
                    "id": 2
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "repeated",
                    "type": "IntoHistoryInfo",
                    "name": "intoHistoryInfos",
                    "id": 1
                }
            ]
        },
        {
            "name": "IntoHistoryInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomUid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomId",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "timeDifference",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "grade",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "onlineFlag",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "privateLiveFlag",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "fee",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "officialAuth",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "vipLevel",
                    "id": 13
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/header/history/history.pb.js